<script>
  import { onMount, afterUpdate } from 'svelte';
  import uuid from 'uuid';
  import { Link, navigate } from 'svelte-routing';
  import {
    axios,
    Store,
    fatch,
    languageStore,
    templateStore,
    pathStore,
    entryStore,
  } from '../../../config.svelte';
  import Select from '../../../components/global/select/select.svelte';
  import SelectItem from '../../../components/global/select/select-item.svelte';
  import TextInput from '../../../components/global/text-input.svelte';
  import NumberInput from '../../../components/global/number-input.svelte';
  import { simplePopup } from '../../../components/simple-popup.svelte';
  import Layout from '../../../components/global/layout.svelte';
  import Button from '../../../components/global/button.svelte';
  import EntryList from '../../../components/entry/entry-list.svelte';
  import DataModelModal from '../../../components/entry/modals/add-data-model.svelte';
  import ViewDataModelModal from '../../../components/entry/modals/view-data-model.svelte';
  import OverflowMenu from '../../../components/global/overflow-menu.svelte';
  import OverflowMenuItem from '../../../components/global/overflow-menu-item.svelte';
  import UrlQueries from '../../../url-queries.js';
  import Base64 from '../../../base64.js';
  import StringUtil from '../../../string-util.js';

  const accessToken = JSON.parse(
    Base64.decode(Store.get('accessToken').split('.')[1]),
  );
  const allowedEntriesPerPage = [10, 20, 30];
  const addDataModalModalEvents = { callback: addNewDataModelEntry };
  const editDataModelModalEvents = { callback: updateDataModalEntry };
  const viewDataModelModalEvents = {};
  const screenWidth = window.innerWidth;
  let show = screenWidth < 900 ? false : true;
  let queries = UrlQueries.get();
  let languages = [];
  let languageSelected = {
    code: 'en',
  };
  let entriesPerPage = 10;
  let allEntries;
  let entries;
  let editEntry;
  let template;
  let templatePolicy;
  let page = 1;
  let filters = [];
  let sort = {
    createdAt: '',
  };
  let templates = [];

  languageStore.subscribe(value => {
    languages = value;
    languageSelected = languages.find(e => e.code === queries.lng);
    if (!languageSelected) {
      languageSelected = {
        code: 'en',
      };
    }
  });
  templateStore.subscribe(value => {
    templates = value;
    if (queries.cid) {
      template = templates.find(e => e._id === queries.cid);
      if (allEntries) {
        entries = allEntries.filter(e => e.templateId === template._id);
        getData();
      }
    }
  });
  entryStore.subscribe(value => {
    allEntries = value;
    if (template) {
      entries = allEntries.filter(e => e.templateId === template._id);
      getData();
    }
  });
  pathStore.subscribe(value => {
    setTimeout(() => {
      queries = UrlQueries.get();
      getData();
    }, 100);
  });

  if (Store.get('entriesPerPage')) {
    entriesPerPage = Store.get(entriesPerPage);
  }

  async function deleteEntry(entry) {
    if (
      confirm(
        `Are you sure you want to delete '${entry._id}'? ` +
          `This action is irreversable!`,
      )
    ) {
      const result = await axios.send({
        url: `/template/${template._id}/entry/${entry._id}`,
        method: 'DELETE',
      });
      if (result.success === false) {
        simplePopup.error(result.error.response.data.message);
        return;
      }
      simplePopup.success(`Entry '${entry._id}' deleted successfully!`);
      entries = entries.filter(e => e._id !== entry._id);
    }
  }
  function setEntriesPerPage(event) {
    entriesPerPage = parseInt(event.target.value, 10);
    entries = [...entries];
  }
  function addEntry() {
    if (template.type === 'DATA_MODEL') {
      addDataModalModalEvents.toggle();
    } else {
      navigate(
        `/dashboard/template/entry/rc` +
          `?tid=${template._id}&lng=${languageSelected.code}`,
      );
    }
  }
  async function addNewDataModelEntry(data) {
    const result = await axios.send({
      url: `/template/${template._id}/entry`,
      method: 'POST',
      data,
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    simplePopup.success('Entry added successfully!');
    entries = [...entries, result.response.data.entry];
    template.entryIds = [...template.entryIds, result.response.data.entry._id];
    Store.remove('entryPropsBuffer');
  }
  async function updateDataModalEntry(data) {
    const result = await axios.send({
      url: `/template/${template._id}/entry`,
      method: 'PUT',
      data: {
        _id: editEntry._id,
        content: data.content,
      },
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    simplePopup.success('Entry added successfully!');
    entries = entries.map(e => {
      if (e._id === result.response.data.entry._id) {
        return result.response.data.entry;
      }
      return e;
    });
    editEntry = undefined;
  }
  function contentToSchema(content) {
    let schema = {};
    for (const i in content) {
      const c = content[i];
      schema[c.lng] = propsToSchema(c.props);
    }
    return JSON.stringify(schema, null, '  ');
  }
  function propsToSchema(props) {
    let schema = {};
    for (const i in props) {
      const prop = props[i];
      if (prop.type === 'GROUP_POINTER') {
        schema[prop.name] = propsToSchema(prop.value.props);
      } else if (prop.type === 'DATE') {
        schema[prop.name] = new Date(prop.value).toISOString();
      } else {
        schema[prop.name] = prop.value;
      }
    }
    return schema;
  }
  function compileSchema(schema) {
    return schema
      .split('":')
      .map(e => {
        let lastIndex = 0;
        let index = 0;
        while (true) {
          index = e.indexOf('"', index + 1);
          if (index === -1) {
            break;
          }
          lastIndex = 0 + index;
        }
        return e.slice(0, lastIndex) + e.slice(lastIndex + 1);
      })
      .join('":')
      .replace(/":/g, ':');
  }
  function sortEntries() {
    if (sort.createdAt !== '') {
      switch (sort.createdAt) {
        case 'newest':
          {
            entries.sort((a, b) => {
              if (a.createdAt > b.createdAt) {
                return -1;
              } else if (a.createdAt < b.createdAt) {
                return 1;
              }
              return 0;
            });
          }
          break;
        case 'oldest':
          {
            entries.sort((a, b) => {
              if (a.createdAt > b.createdAt) {
                return 1;
              } else if (a.createdAt < b.createdAt) {
                return -1;
              }
              return 0;
            });
          }
          break;
      }
    }
  }
  async function filterEntry() {
    if (filters.length === 0) {
      entries = allEntries.filter(entry => entry.templateId === template._id);
      return;
    }
    const result = await axios.send({
      url: `/template/${template._id}/entry/filter?filters=${encodeURIComponent(
        btoa(JSON.stringify(filters)),
      )}&lng=${languageSelected.code}`,
      method: 'GET',
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    let bufferEntries = allEntries.filter(
      entry => entry.templateId === template._id,
    );
    if (result.response.data.filter.length > 0) {
      bufferEntries = bufferEntries.filter(entry =>
        result.response.data.filter.includes(entry._id),
      );
    } else {
      simplePopup.success(`No entries in the result.`);
    }
    entries = bufferEntries;
  }
  function setFilter(prop, options) {
    const filter = filters.find(e => e.name === prop.name);
    if (filter) {
      switch (prop.type) {
        case 'ENUMERATION':
          {
            if (options.selected === '') {
              filters = filters.filter(e => e.name !== filter.name);
            } else {
              filter.selected = options.selected;
            }
          }
          break;
        case 'BOOLEAN':
          {
            if (options === '') {
              filters = filters.filter(e => e.name !== filter.name);
            } else {
              filter.value = options === 'true' ? true : false;
            }
          }
          break;
        case 'STRING':
          {
            if (options === '') {
              filters = filters.filter(e => e.name !== filter.name);
            } else if (options.type && options.type !== '') {
              filter.value.type = options.type;
            } else if (options.value && options.value !== '') {
              filter.value.value = options.value;
            }
          }
          break;
        case 'NUMBER':
          {
            if (options === '') {
              filters = filters.filter(e => e.name !== filter.name);
            } else if (options.type && options.type !== '') {
              filter.value.type = options.type;
            } else if (options.value && options.value !== '') {
              filter.value.value = options.value;
            }
          }
          break;
      }
    } else {
      switch (prop.type) {
        case 'ENUMERATION':
          {
            if (options.selected !== '') {
              filters.push({
                name: prop.name,
                type: prop.type,
                selected: options.selected,
              });
            }
          }
          break;
        case 'BOOLEAN':
          {
            if (options) {
              filters.push({
                name: prop.name,
                type: prop.type,
                value: options === 'true' ? true : false,
              });
            }
          }
          break;
        case 'STRING':
          {
            if (options) {
              filters.push({
                name: prop.name,
                type: prop.type,
                value: {
                  type: options.type,
                  value: options.value,
                },
              });
            }
          }
          break;
        case 'NUMBER':
          {
            if (options && options !== '') {
              filters.push({
                name: prop.name,
                type: prop.type,
                value: {
                  type: options.type,
                  value: options.value,
                },
              });
            }
          }
          break;
      }
    }
  }
  async function getData() {
    if (!queries.cid) {
      return;
    }
    if (accessToken.roles[0].name === 'ADMIN') {
      templatePolicy = {
        get: true,
        post: true,
        put: true,
        delete: true,
      };
    } else {
      templatePolicy = accessToken.customPool.policy.templates.find(
        e => e._id === queries.cid,
      );
    }
    template = templates.find(e => e._id === queries.cid);
    entries = allEntries.filter(e => e.templateId === template._id);
  }

  onMount(async () => {
    fatch();
    getData();
  });
</script>

<style type="text/scss">
  @import './view.scss';
</style>

<Layout>
  <div key={uuid.v4()} class="manager">
    {#if show === true}
      <div class="menu">
        <div class="section">
          <div class="heading">Filters</div>
          <Button
            class="ml-auto"
            kind="ghost"
            icon="fas fa-filter"
            on:click={async () => {
              await filterEntry();
              sortEntries();
            }}>
            Apply
          </Button>
        </div>
        {#if template && entries}
          <div class="filters mt-20">
            <div class="filter">
              <Select
                labelText="Sort by date created"
                helperText="Sort entries by the date they were created."
                selected=""
                on:change={event => {
                  if (event.eventPhase === 0 && event.returnValue === true) {
                    sort.createdAt = event.detail;
                  }
                }}>
                <SelectItem value="">- Unselected -</SelectItem>
                <SelectItem value="newest">Newest First</SelectItem>
                <SelectItem value="oldest">Oldest First</SelectItem>
              </Select>
            </div>
            <div class="filter">
              <Select
                labelText="Title"
                helperText="Select a type of string search."
                on:change={event => {
                  if (event.eventPhase === 0 && typeof event.detail === 'string') {
                    if (event.detail === '') {
                      setFilter({ type: 'STRING', name: 'root_title' }, '');
                    } else {
                      setFilter({ type: 'STRING', name: 'root_title' }, { type: event.detail, value: '' });
                    }
                    filters = [...filters];
                  }
                }}>
                <SelectItem value="" text="- Unselected -" />
                <SelectItem value="contains" text="Contains" />
                <SelectItem value="regex" text="Regex" />
              </Select>
              {#if filters.find(e => e.name === 'root_title')}
                <TextInput
                  class="mt-20"
                  labelText="Search for"
                  placeholder="- Type a string to find -"
                  on:input={event => {
                    if (event.eventPhase === 0) {
                      setFilter({ type: 'STRING', name: 'root_title' }, { value: event.detail });
                    }
                  }} />
              {/if}
            </div>
            {#each template.entryTemplate as prop}
              {#if prop.type === 'ENUMERATION'}
                <div class="filter">
                  <Select
                    labelText={StringUtil.prettyName(prop.name)}
                    helperText="Show Entries with selected enumeration."
                    selected=""
                    on:change={event => {
                      if (event.eventPhase === 0 && typeof event.detail === 'string') {
                        setFilter(prop, { selected: event.detail });
                      }
                    }}>
                    <SelectItem value="" text="- Unselected -" />
                    {#each prop.value.items as item}
                      <SelectItem
                        value={item}
                        text={StringUtil.prettyName(item)} />
                    {/each}
                  </Select>
                </div>
              {:else if prop.type === 'BOOLEAN'}
                <div class="filter">
                  <Select
                    labelText={StringUtil.prettyName(prop.name)}
                    helperText="Show Entries with boolean state."
                    selected={languageSelected.code}
                    on:change={event => {
                      if (event.eventPhase === 0 && typeof event.detail === 'string') {
                        setFilter(prop, event.detail);
                      }
                    }}>
                    <SelectItem value="" text="- Unselected -" />
                    <SelectItem value="true" text="True" />
                    <SelectItem value="false" text="False" />
                  </Select>
                </div>
              {:else if prop.type === 'STRING'}
                <div class="filter">
                  <Select
                    labelText={StringUtil.prettyName(prop.name)}
                    helperText="Select type of string search."
                    on:change={event => {
                      if (event.eventPhase === 0 && typeof event.detail === 'string') {
                        if (event.detail === '') {
                          setFilter(prop, '');
                        } else {
                          setFilter(prop, { type: event.detail, value: '' });
                        }
                        template.entryTemplate = JSON.parse(JSON.stringify(template.entryTemplate));
                      }
                    }}>
                    <SelectItem value="" text="- Unselected -" />
                    <SelectItem value="contains" text="Contains" />
                    <SelectItem value="regex" text="Regex" />
                  </Select>
                  {#if filters.find(e => e.name === prop.name)}
                    <TextInput
                      class="mt-20"
                      labelText="Search for"
                      placeholder="- Type a string to find -"
                      on:input={event => {
                        if (event.eventPhase === 0) {
                          setFilter(prop, { value: event.detail });
                        }
                      }} />
                  {/if}
                </div>
              {:else if prop.type === 'NUMBER'}
                <div class="filter">
                  <Select
                    labelText={StringUtil.prettyName(prop.name)}
                    helperText="Select type of number search."
                    on:change={event => {
                      if (event.eventPhase === 0 && event.returnValue === true) {
                        if (event.detail === '') {
                          setFilter(prop, '');
                        } else {
                          setFilter(prop, { type: event.detail, value: 0 });
                        }
                        template.entryTemplate = JSON.parse(JSON.stringify(template.entryTemplate));
                      }
                    }}>
                    <SelectItem value="" text="- Unselected -" />
                    <SelectItem value="=" text="Equal" />
                    <SelectItem value=">=" text="Grater or equal" />
                    <SelectItem value="<=" text="Less or equal" />
                  </Select>
                  {#if filters.find(e => e.name === prop.name)}
                    <NumberInput
                      value="0"
                      class="mt-20"
                      labelText="Search for"
                      placeholder="- Type a string to find -"
                      on:change={event => {
                        if (event.eventPhase === 0) {
                          const filter = filters.find(e => e.name === prop.name);
                          if (filter) {
                            filter.value.value = event.detail;
                          }
                        }
                      }} />
                  {/if}
                </div>
              {/if}
            {/each}
          </div>
        {/if}
      </div>
    {/if}
    {#if screenWidth < 900}
      <div class="toggle-menu {show === true ? 'toggle-menu-show' : ''}">
        <Button
          icon="fas fa-bars"
          onlyIcon={true}
          on:click={() => {
            show = !show;
          }} />
      </div>
    {/if}
    <div class="content">
      <div class="content-wrapper">
        {#if template && entries}
          <div class="heading">
            <div class="text">
              <h2>{StringUtil.prettyName(template.name)}</h2>
              <div class="entry-count">
                {template.entryIds.length} Entries found
              </div>
            </div>
            <div class="action">
              {#if templatePolicy.post === true}
                <Button icon="fas fa-plus" on:click={addEntry}>
                  Add new Entry
                </Button>
              {/if}
            </div>
          </div>
          <div class="options mt-20">
            <Select
              labelText="View language"
              helperText="Entry result will be shown in selected language."
              selected={languageSelected.code}
              on:change={event => {
                if (event.eventPhase === 0 && event.returnValue === true) {
                  const l = languages.find(e => (e.code = event.detail));
                  if (l) {
                    languageSelected = l;
                  }
                }
              }}>
              {#each languages as lng}
                <SelectItem
                  value={lng.code}
                  text="{lng.name} | {lng.nativeName}" />
              {/each}
            </Select>
          </div>
          {#if entries.length > 0}
            <EntryList
              class="mt-50"
              {entries}
              lng={languageSelected.code}
              {templatePolicy}
              on:data={event => {
                if (event.eventPhase === 0) {
                  viewDataModelModalEvents.setDataModel(event.detail);
                  viewDataModelModalEvents.toggle();
                }
              }}
              on:edit={event => {
                if (event.eventPhase === 0) {
                  navigate(`/dashboard/template/entry/rc` + `?tid=${template._id}&eid=${event.detail._id}&lng=${languageSelected.code}`);
                }
              }}
              on:delete={event => {
                if (event.eventPhase === 0) {
                  deleteEntry(event.detail);
                }
              }} />
          {:else}
            <div class="no-entries">There are no Entries in this Template</div>
          {/if}
        {:else}
          <div class="no-template">Template was not provided.</div>
        {/if}
      </div>
    </div>
  </div>
</Layout>

<ViewDataModelModal events={viewDataModelModalEvents} />
{#if template && languages.length > 0}
  <DataModelModal events={editDataModelModalEvents} {template} {languages} />
  <DataModelModal events={addDataModalModalEvents} {template} {languages} />
{/if}
